import { render, staticRenderFns } from "./esportazioneVerbali.vue?vue&type=template&id=5fb33ef0"
import script from "./esportazioneVerbali.vue?vue&type=script&lang=js"
export * from "./esportazioneVerbali.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports